import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Telephone(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M22.047 9.1a2 2 0 01-1.998 1.9h-1.931a2 2 0 01-1.789-1.106l-.56-1.12c-.94-.369-3.927-1.297-7.549.021l-.55 1.1A2 2 0 015.883 11H4a2 2 0 01-2-2V7.883c0-2.136 1.364-4.111 3.498-4.688 5.296-1.43 9.31-1.33 13.97.867 1.767.833 2.697 2.681 2.604 4.527l-.025.512zM18.118 9h1.931l.026-.512c.057-1.143-.52-2.174-1.46-2.617-4.147-1.954-7.659-2.078-12.596-.745C4.83 5.448 4 6.576 4 7.883V9h1.882l.554-1.107a1.963 1.963 0 011.076-.968c4.353-1.594 7.947-.433 9.058.015.456.183.782.529.974.91L18.118 9zM3 19a9.004 9.004 0 016-8.488V10a1 1 0 112 0v.055a9.098 9.098 0 012 0V10a1 1 0 012 0v.512A9.004 9.004 0 0121 19v2a1 1 0 01-1 1H4a1 1 0 01-1-1v-2zm9-7a7 7 0 00-7 7v1h14v-1a7 7 0 00-7-7zm1 4a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z",
    clipRule: "evenodd"
  }));
}

export default Telephone;